import { render, staticRenderFns } from "./delPaper.vue?vue&type=template&id=3e8e8a5e&scoped=true&"
import script from "./delPaper.vue?vue&type=script&lang=js&"
export * from "./delPaper.vue?vue&type=script&lang=js&"
import style0 from "./delPaper.vue?vue&type=style&index=0&id=3e8e8a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8e8a5e",
  null
  
)

export default component.exports